module.exports = __webpack_public_path__ + "img/switch_img2_msg4.4104a084.png";